export default __webpack_public_path__ + "static/media/icon-wallet.fade0d04.svg";